import CONFIGURACIONES from "../../../../util/constants";
import OWASP from "../../../../util/owasp";
import WaveButton from "../../../global/WaveButton";

import { useForm } from "react-hook-form";

const MantClients = ( {idEdit, clicButtonAdd, saveClient, closeSection}) => {
    const { register, handleSubmit, setValue, formState: { errors } } = useForm({mode: "onChange"});
  
    
    const onSubmit1 = (form) => {
        // console.log('form', form);
        saveClient(form);
        // eventNextButton();
    };

    return (
        <>
        {idEdit == CONFIGURACIONES.INIT.NUMBER && <WaveButton className="btn btn-danger btn-block waves-effect" onClick={ clicButtonAdd }>
            <i className="mdi mdi-plus"></i> Registrar Demo
        </WaveButton>}

        {(idEdit > CONFIGURACIONES.INIT.NUMBER || idEdit == CONFIGURACIONES.INIT.ID_ADD) && <div className="card">
            <div className="card-body">
                <h5 className="card-title font-weight-bold">Registrar Demo</h5>

                <div className="card-content">
                    <form action="" className="form" onSubmit={handleSubmit(onSubmit1)}>
                        <div className="row">
                            <div className="col-sm-12 col-md-6">
                                <div className="form-group">
                                    <label htmlFor="inputname" className="control-label col-form-label">First Name</label>
                                    <input 
                                        {...register("firstName", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_LETTERS,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                        type="text" className="form-control" id="inputname" placeholder="First Name Here" />
                                    <small className="invalid-feedback"> { errors.firstName && errors.firstName.message }</small>           
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-6">
                                <div className="form-group">
                                    <label htmlFor="inputname" className="control-label col-form-label">Second Name</label>
                                    <input 
                                        {...register("secondName", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_LETTERS,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}
                                        type="text" className="form-control" id="inputname" placeholder="Second Name Here" />
                                        <small className="invalid-feedback"> { errors.secondName && errors.secondName.message }</small>
                                </div>
                            </div>
                            {/* <div className="col-6">hola</div>
                            <div className="col-6">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Modi praesentium magnam et laborum accusantium nesciunt sit nobis cum ab minima, similique repellat ad quas accusamus temporibus eveniet, officiis aliquam enim!</div> */}
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-6">
                                <div className="form-group">
                                    <label className="control-label col-form-label">Priority</label>
                                    <select className="form-control"
                                        {...register("priority", {
                                            required: OWASP.REQUIRED,
                                            pattern: {
                                                value: OWASP.VALIDATIONS.ONLY_NUMBERS_INTEGER,
                                                message: OWASP.MESSAGES.DEFAULT
                                            }
                                        })}>
                                        <option value="1">Low</option>
                                        <option>Medium</option>
                                        <option>High</option>
                                    </select>
                                    <small className="invalid-feedback"> { errors.priority && errors.priority.message }</small>
                                </div>
                            </div>
                        </div>
                        <div className="action-form mt-3">
                            <div className="form-group mb-0 text-left">
                                <WaveButton type="button" onClick={ closeSection } className="btn btn-sm btn-outline-danger waves-effect">
                                    <i className="mdi mdi-arrow-left"></i> Cerrar
                                </WaveButton>
                                { idEdit == CONFIGURACIONES.INIT.ID_ADD &&  <WaveButton type="submit" className="btn btn-sm btn-success waves-effect ml-2">
                                    <i className="mdi mdi-content-save-settings"></i> Guardar
                                </WaveButton>}

                                { idEdit > CONFIGURACIONES.INIT.NUMBER && <WaveButton type="submit" className="btn btn-sm btn-info waves-effect ml-2">
                                    <i className="mdi mdi-content-save-settings"></i> Modificar
                                </WaveButton>}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>}
        </>
    )
}
export default MantClients;